import styled from "styled-components";

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #002244;
  margin: 0 0 24px 0;
`;

export const IconGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 8px;
  padding: 8px 0;
  max-height: 550px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

export const IconButton = styled.button`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 20px;
  color: #002244;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #002244;
    border-color: #002244;
    color: #ffffff;
    transform: scale(1.05);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
